import { CustomerMutationTypes } from '@/store/modules/customer'

import { AuthMutationTypes } from './AuthMutationTypes'
import { State } from './index'

// We have to duplicate login state in localStorage, because of
// store does not share its state between browser tabs.
export default {
  [AuthMutationTypes.LoginSuccess](state: State) {
    state.logined = true
    localStorage.setItem('logined', 'true')
  },
  [AuthMutationTypes.LoginFailure](state: State) {
    state.logined = false
    localStorage.setItem('logined', 'false')
  },
  [AuthMutationTypes.RegistrationSuccess](state: State) {
    state.logined = true
    localStorage.setItem('logined', 'true')
  },
  [AuthMutationTypes.RegistrationFailure](state: State) {
    state.logined = false
    localStorage.setItem('logined', 'false')
  },
  [CustomerMutationTypes.GetCurrentSuccess](state: State) {
    state.logined = true
    localStorage.setItem('logined', 'true')
  },
  [CustomerMutationTypes.GetCurrentFailure](state: State) {
    state.logined = false
    localStorage.setItem('logined', 'false')
  },
  [AuthMutationTypes.Logout](state: State) {
    state.logined = false
    localStorage.setItem('logined', 'false')
  },
  [AuthMutationTypes.LogoutFailure](state: State) {
    state.logined = true
    localStorage.setItem('logined', 'true')
  },
}
